import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { hasAccess } from "@/lib/roles";

export default function AgentLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const u = await login(email, password);
      if (!hasAccess(u.role, "agent")) { toast.error("Agent access required"); setBusy(false); return; }
      nav("/agent");
    } catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy px-6" data-testid="agent-login-page">
      <div className="max-w-md w-full">
        <div className="text-center mb-8 flex flex-col items-center">
          <Logo size={72} color="#F7F5F0" />
          <div className="font-serif text-3xl text-white mt-3">Aperture</div>
          <div className="eyebrow" style={{ color: "#C4A265", fontSize: "0.65rem" }}>Agent Portal</div>
          <div className="mt-3 text-[10px] text-white/40 uppercase tracking-widest">FloridaTaxProperty.com</div>
        </div>
        <form onSubmit={submit} className="bg-white p-8 shadow-2xl rounded-sm space-y-4">
          <input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Email" data-testid="agent-login-email"
            className="w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gold text-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
          <input required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Password" data-testid="agent-login-password"
            className="w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gold text-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
          <button disabled={busy} data-testid="agent-login-submit" className="btn-primary w-full py-3 text-xs uppercase tracking-widest rounded-sm">{busy ? "…" : "Sign in"}</button>
          <div className="pt-1 text-center">
            <Link to="/forgot-password" data-testid="agent-login-forgot-password-link" className="text-xs text-navy/60 hover:text-gold transition-colors">Forgot your password?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
